// extracted by mini-css-extract-plugin
export default {"viewerCountWrapper":"viewerCountWrapper__IMMEn","viewerCount":"viewerCount__bWy2e"};